module.exports = __webpack_public_path__ + "img/MultipleUsers.3b2bd8ae.svg";